import { render, staticRenderFns } from "./CustomerCreateModal.vue?vue&type=template&id=97167df6&scoped=true&"
import script from "./CustomerCreateModal.vue?vue&type=script&lang=js&"
export * from "./CustomerCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97167df6",
  null
  
)

export default component.exports